/** @format */

import React from "react";
import ReactDOM from "react-dom";
import "moment/locale/it";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ConfigProvider } from "antd";
import itIT from "antd/es/locale/it_IT";
import moment from "moment";
import { Provider } from "react-redux";
import { configureStore, history } from "./redux-modules/configureStore";
import { BrowserRouter as Router } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
moment.locale("it");

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ConfigProvider locale={itIT}>
        <App />
      </ConfigProvider>
    </ConnectedRouter>
  </Provider>,

  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
